import axios from 'axios'
import qs from 'qs'

export const getCategoriesAndProviderSearch = (params, centerId) =>
  axios.get(`/api/search?${qs.stringify(params, { skipNulls: true })}`, { headers: { 'X-Center-Id': centerId } })
